var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEnterFullscreen = function SvgEnterFullscreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 1.5A1.5 1.5 0 0 0 1.5 3v5.25a.75.75 0 0 0 1.5 0V3h5.25a.75.75 0 0 0 0-1.5H3ZM21 22.5a1.5 1.5 0 0 0 1.5-1.5v-5.25a.75.75 0 0 0-1.5 0V21h-5.25a.75.75 0 0 0 0 1.5H21ZM3 22.5A1.5 1.5 0 0 1 1.5 21v-5.25a.75.75 0 0 1 1.5 0V21h5.25a.75.75 0 0 1 0 1.5H3ZM22.5 3A1.5 1.5 0 0 0 21 1.5h-5.25a.75.75 0 0 0 0 1.5H21v5.25a.75.75 0 0 0 1.5 0V3Z"
  })));
};

export default SvgEnterFullscreen;